import React, { useState } from "react";
import { Calculator } from "lucide-react";

import "./ui/styles.css";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Label } from "./ui/label";
import { Input } from "./ui/input";

const parsePercent = (p) =>
  parseFloat(p.replace(/[+%]/g, "")) || 0;

// const parseLeverage = (l) =>
//   l ? parseFloat(l.replace(/x/i, "")) || 1 : 1;
const parseLeverage = (l) => 1;

const CalculateDialog = ({ signal }) => {
  const [invest, setInvest] = useState("100");

  const investNum = parseFloat(invest) || 0;
  const leverage = parseLeverage(signal.leverage);

  const calcProfit = (percentStr) => {
    const pct = parsePercent(percentStr);
    return (investNum * pct * leverage) / 100;
  };

  return (
    <Dialog>
      <DialogTrigger asChild onClick={(e) => e.stopPropagation()}>
        <Button
          className="custom-signal-com-required-calc-btn"
          title="Calculate profit"
        >
          <Calculator size={16} />
        </Button>
      </DialogTrigger>

      <DialogContent
        className="custom-signal-com-required-dialog-md"
        onClick={(e) => e.stopPropagation()}
      >
        <DialogHeader>
          <DialogTitle className="custom-signal-com-required-flex custom-signal-com-required-center custom-signal-com-required-gap-2 custom-signal-com-required-title">
            <Calculator size={18} style={{ color: '#1dafa1' }} />
            Profit Calculator
          </DialogTitle>
        </DialogHeader>

        {/* TOP CARD */}
        <div className="custom-signal-com-required-card custom-signal-com-required-space-y">
          <div className="custom-signal-com-required-flex custom-signal-com-required-between custom-signal-com-required-center">
            <span className="custom-signal-com-required-text-sm custom-signal-com-required-bold">
              {signal.pair}
            </span>

            <div className="custom-signal-com-required-flex custom-signal-com-required-center custom-signal-com-required-gap-1">
              <Badge>{signal.type}</Badge>

              {signal.leverage && (
                <Badge variant="outline">
                  {signal.leverage} • {signal.direction}
                </Badge>
              )}
            </div>
          </div>

          <div className="custom-signal-com-required-flex custom-signal-com-required-between custom-signal-com-required-text-xs">
            <span className="custom-signal-com-required-muted">
              Entry Rate
            </span>
            <span className="custom-signal-com-required-bold">
              {signal.entry}
            </span>
          </div>
        </div>

        {/* INPUT */}
        <div className="custom-signal-com-required-space-y">
          <Label htmlFor="usdt-invest">USDT Invest</Label>

          <Input
            id="usdt-invest"
            type="number"
            min="0"
            value={invest}
            onChange={(e) => setInvest(e.target.value)}
            placeholder="Enter USDT amount"
          />

          {/* {signal.leverage && (
            <p className="custom-signal-com-required-text-11 custom-signal-com-required-muted"> */}
              {/* Position size with {leverage}x leverage:{" "} */}
              {/* <span className="custom-signal-com-required-bold">
                {(investNum * leverage).toFixed(2)} USDT
              </span>
            </p>
          )} */}
        </div>

        {/* TARGETS */}
        <div className="custom-signal-com-required-space-y pt-2">
          {signal.targets.map((t) => {
            const profit = calcProfit(t.percent);

            return (
              <div
                key={t.label}
                className="custom-signal-com-required-profit-box custom-signal-com-required-flex custom-signal-com-required-between custom-signal-com-required-center"
              >
                <div>
                  <div className="custom-signal-com-required-text-xs custom-signal-com-required-muted">
                    {t.label} @ {t.price}
                  </div>

                  <div className="custom-signal-com-required-text-10 custom-signal-com-required-muted">
                    {t.percent}
                    {leverage > 1 ? ` × ${leverage}x` : ""}
                  </div>
                </div>

                <div className="custom-signal-com-required-text-right">
                  <div className="custom-signal-com-required-text-10 custom-signal-com-required-muted">
                    Profit
                  </div>

                  <div className="custom-signal-com-required-text-sm custom-signal-com-required-bold custom-signal-com-required-success">
                    +{profit.toFixed(2)} USDT
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CalculateDialog;